import styled from 'styled-components';
import Select from 'components/Inputs/Select';
import { H1 } from 'components/Typography';
import { sizes } from 'style';
import { th } from 'style/theme';

export const HeaderWrapper = styled.div`
  width: 100%;
  max-width: 350px;
  display: flex;
  flex-direction: column;

  @media ${sizes.tabletPortrait} {
    flex-direction: row;
    max-width: initial;
  }

  @media ${sizes.desktop} {
    display: inline-flex;
    width: 524px;
  }

  @media ${sizes.mediumLargeDesktop} {
    display: flex;
    width: 100%;
    align-items: center;
    max-width: initial;
  }
`;

export const Title = styled(H1)`
  @media ${sizes.tabletPortrait} {
    margin-right: 34px;
  }
`;

export const Categories = styled.div`
  display: none;

  @media ${sizes.mediumLargeDesktop} {
    display: flex;
    user-select: none;
    margin-top: 8px;
  }
`;

export const Category = styled.div`
  opacity: ${({ selected }) => (selected ? 1 : 0.3)};
  margin: 0 8px;
  transition: opacity 200ms;
  cursor: pointer;

  :hover {
    color: ${th('colors.charlotte')};
    opacity: 1;
  }

  @media ${sizes.largeDesktop} {
    margin: 0 14px;
  }
`;

export const CategorySelect = styled(Select)`
  margin-top: 16px;
  width: 100%;
  z-index: 2;

  @media ${sizes.mobileLarge} {
    max-width: 300px;
  }

  @media ${sizes.tabletPortrait} {
    margin-top: 10px;
  }

  @media ${sizes.mediumLargeDesktop} {
    display: none;
  }
`;
